import { useQuery } from 'react-apollo';
import {
  Investment_IdeaType,
  Lab_CommonProductType,
} from '../../../../../../../__generated__/globalTypes';
import * as query from './query.gql';
import { ActiveOrderQuery, ActiveOrderQueryVariables } from './__generated__/ActiveOrderQuery';

const mapIdeaTypeToProductType: Record<Investment_IdeaType, Lab_CommonProductType> = {
  BUY_AND_HOLD: Lab_CommonProductType.BUY_AND_HOLD,
  LIMITED: Lab_CommonProductType.LIMITED,
  UNLIMITED: Lab_CommonProductType.UNLIMITED,
};

export const useActiveOrder = (id: number, ideaType: Investment_IdeaType) => {
  const { data, loading } = useQuery<ActiveOrderQuery, ActiveOrderQueryVariables>(query, {
    variables: {
      id,
      productType: mapIdeaTypeToProductType[ideaType],
    },
  });

  return {
    order: data?.lab.buyOrder,
    loading,
  };
};
